import axios from "axios";
import { StringDecoder } from "string_decoder";
import {
  GetAllSupplyPayload,
  UpdatePercentagePayload,
} from "./carSegmentSupplyInterfaces";

export { carSegmentSupplyActions };

axios.defaults.withCredentials = true

function carSegmentSupplyActions() {
  const baseUrl = ``;
  const tenantVal = `${process.env.REACT_APP_TENANT}`;

  return {
    getAll,
    updatePercentage,
    resetPercentage,
    downloadExcel,
  };

  async function getAll(
    tenant: string ,
    yearFrom: number,
    yearTo: number,
    monthFrom: number,
    monthTo: number
  ) {
    const params = {
      tenant: tenant ,
      yearFrom: yearFrom,
      yearTo: yearTo,
      monthFrom: monthFrom,
      monthTo: monthTo,
    };

    return new Promise(function (resolve, reject) {
      axios
        .get(`${baseUrl}/fleetplanning/segmentsupplydetermination/range`, {
          params,
          
        })
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  async function updatePercentage(tenant: string ,payload: UpdatePercentagePayload) {
    return new Promise(function (resolve, reject) {
      axios
        .put(
          `${baseUrl}/fleetplanning/segmentsupplydetermination/updatepercentage`,
          payload, {params:{tenant:tenant}}
        )
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error.response);
        });
    });
  }

  async function resetPercentage(tenant: string ,payload: UpdatePercentagePayload) {
    return new Promise(function (resolve, reject) {
      axios
        .put(
          `${baseUrl}/fleetplanning/segmentsupplydetermination/resetpercentage`,
          payload, {params:{tenant:tenant}}
        )
        .then(function (response) {
          resolve(response.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  async function downloadExcel(
    tenant: string ,
    yearFrom: number,
    yearTo: number,
    monthFrom: number,
    monthTo: number
  ) {
    const params = {
      tenant: tenant ,
      yearFrom: yearFrom,
      yearTo: yearTo,
      monthFrom: monthFrom,
      monthTo: monthTo,
    };

    return new Promise(function (resolve, reject) {
      axios
        .get(`${baseUrl}/fleetplanning/segmentsupplydetermination/excel`, {
          params,
          responseType: "arraybuffer",
          headers: { "Access-Control-Allow-Origin": true },
        })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
